'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('otppLogin', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      allowRemembered: '='
    },
    controller: 'LoginCtrl as loginCtrl',
    templateUrl: 'scripts/directives/otpp-login/otpp-signin.prt.html'
  };
});
